"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "Editor" */ './lazyIndex');
});
exports.ReactEditor = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ReactEditor; });
exports.lazyCreateUndo = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createUndo; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor/lib/index.js
// module id = 2159
// module chunks = 2 3 86 108